import { Component, inject } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
// Directive for scroll animations
import { ScrollAnimateDirective } from '../../directives/scroll-animate.directive';
// Service for handling navigation to contact form
import { NavigationService } from '../../Services/navigation.service';

// Service data interface for type safety
interface Service {
  title: string;
  bookingName: string;
  serviceId: string;
  image: string;
  text: string;
  bulletPoints: string[];
}

@Component({
  selector: 'app-our-services',
  imports: [
    UpperCasePipe,
    ScrollAnimateDirective
  ],
  templateUrl: './our-services.html',
  styleUrl: './our-services.scss',
})
export class OurServices {
  // Injected navigation service for smooth scrolling to contact form
  private navigationService = inject(NavigationService);

  // Array of services with title, booking name, service ID, image, description text, and bullet points
  services: Service[] = [
    {
      title: 'Floor Installation',
      bookingName: 'Installation',
      serviceId: 'installation',
      image: '/services/floorInstallation.webp',
      text: 'Professional installation of quality timber flooring using modern techniques, premium materials and precise measurements to ensure long-lasting, flawless results.',
      bulletPoints: [
        'Parquet flooring installation',
        'Subfloor preparation and levelling',
        'Solid hardwood flooring installation',
        'Engineered timber floor installation',
        'Hybrid and laminate flooring installation'
      ]
    },
    {
      title: 'Floor Sanding',
      bookingName: 'Sanding',
      serviceId: 'sanding',
      image: '/services/floorSanding.webp',
      // floorSanding.jpg
      text: 'Expert dust-free sanding to restore the natural beauty of your timber floors by removing old coatings, scratches, and imperfections for a smooth finish.',
      bulletPoints: [
        'Dust-free sanding technology',
        'Multiple grit level sanding process',
        'Edge and corner sanding',
        'Gap filling and repair',
        'Surface preparation for coating'
      ]
    },
    {
      title: 'Floor Staining',
      bookingName: 'Stain',
      serviceId: 'colouring',
      image: '/services/FloorColouring1.webp',
      text: 'Floor colour is one of the most important elements of interior design. We offer a wide range of tones — from light to rich, deep shades — using quality wood stains that enhance the natural grain and character of the timber.',
      bulletPoints: [
        'Wide range of colour tones',
        'Quality wood stains',
        'Natural grain enhancement',
      ]
    },
    {
      title: 'Floor Varnishing',
      bookingName: 'Varnishing',
      serviceId: 'coating',
      image: '/services/FloorCoating(Lacquering)2.webp',
      text: 'Our lacquering service provides a durable matte or semi-matte finish. We use water-based lacquers that are environmentally friendly and offer long-lasting protection for your floor.',
      bulletPoints: [
        'Quick drying time',
        'Low VOC emissions',
        'Water-based eco-friendly coatings',
        'Matte and semi-matte finish options',
        'Durable 2K coating for high-wear areas'
      ]
    },
    {
      title: 'Floor Polishing',
      bookingName: 'Polishing',
      serviceId: 'oil-finishing',
      image: '/services/OilFinishing1.webp',
      text: 'Natural oil penetrates deep into the wood fibres, protecting the floor from the inside while preserving its natural look and texture. Periodic re-oiling is recommended to maintain the protection and the authentic feel of the timber.',
      bulletPoints: [
        'Deep penetrating natural oils',
        'Preserves authentic wood texture',
        'Interior timber floor oil treatment',
        'Maintenance and re-oiling services'
      ]
    },
  ];

  // Navigates to contact form with pre-selected service when booking button is clicked
  async bookService(serviceId: string): Promise<void> {
    await this.navigationService.navigateToContactForm(serviceId);
  }
}
